import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
  AiOutlineMail,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { FiPhoneCall, FiMapPin, FiSend } from "react-icons/fi";
import ScrollReveal from "../ScrollReveal/ScrollReveal";
import ScrollToTop from "../ScrollToTop/ScrollToTop";
import "./contact.css";

const contactMethods = [
  {
    label: "Email",
    value: "itsshankar35@gmail.com",
    href: "mailto:itsshankar35@gmail.com",
    icon: <AiOutlineMail />,
  },
  {
    label: "Phone",
    value: "+977 9807592153",
    href: "tel:+9779807592153",
    icon: <FiPhoneCall />,
  },
  {
    label: "Location",
    value: "Balkumari, Lalitpur, Nepal",
    href: "https://maps.google.com/?q=Balkumari,+Lalitpur,+Nepal",
    icon: <FiMapPin />,
  },
];

const socialLinks = [
  {
    label: "GitHub",
    href: "https://github.com/shankarkharel",
    icon: <AiFillGithub />,
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/in/shankar-kharel-162846168/",
    icon: <FaLinkedinIn />,
  },
  {
    label: "Twitter",
    href: "https://twitter.com/shankarkharel19",
    icon: <AiOutlineTwitter />,
  },
  {
    label: "Instagram",
    href: "https://www.instagram.com/shankarkharel07",
    icon: <AiFillInstagram />,
  },
];

const topics = [
  "Backend engineering role",
  "Consulting project",
  "Product collaboration",
  "Technical discussion",
];

function Contact() {
  const [name, setName] = useState("");
  const [subject, setSubject] = useState("Backend engineering role");
  const [message, setMessage] = useState("");

  const finalSubject = subject || "Contact from portfolio";
  const finalBody = [
    `Hi Shankar,`,
    "",
    name ? `My name is ${name}.` : "",
    message || "I'd like to connect regarding an opportunity.",
    "",
    "Best regards,",
    name || "",
  ]
    .filter(Boolean)
    .join("\n");

  const mailtoHref = `mailto:itsshankar35@gmail.com?subject=${encodeURIComponent(
    finalSubject
  )}&body=${encodeURIComponent(finalBody)}`;
  const gmailComposeHref = `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(
    "itsshankar35@gmail.com"
  )}&su=${encodeURIComponent(finalSubject)}&body=${encodeURIComponent(
    finalBody
  )}`;

  const handleSubmit = (event) => {
    event.preventDefault();
    window.open(gmailComposeHref, "_blank", "noopener,noreferrer");
  };

  return (
    <Container fluid className="contact-section">
      <Container className="section-shell">
        <ScrollReveal as="section" className="contact-hero" distance={24}>
          <div className="section-intro center">
            <span className="section-kicker">Contact</span>
            <h1>Let&apos;s build something useful together.</h1>
            <p className="section-copy">
              Reach out for backend engineering roles, platform work, product
              collaborations, or technical conversations. The form below opens
              a Gmail draft and also provides a `mailto:` fallback.
            </p>
          </div>
        </ScrollReveal>

        <Row className="section-gap align-items-start">
          <Col lg={5}>
            <ScrollReveal className="contact-panel" distance={24}>
              <span className="section-kicker">Direct Reach</span>
              <h2>Fast ways to connect.</h2>
              <div className="contact-methods">
                {contactMethods.map((item) => (
                  <ScrollReveal
                    as="a"
                    className="contact-method-card"
                    href={item.href}
                    target={item.label === "Location" ? "_blank" : undefined}
                    rel={item.label === "Location" ? "noreferrer" : undefined}
                    key={item.label}
                    delay={contactMethods.indexOf(item) * 80}
                    distance={18}
                  >
                    <span className="contact-method-icon">{item.icon}</span>
                    <strong>{item.label}</strong>
                    <small>{item.value}</small>
                  </ScrollReveal>
                ))}
              </div>
              <div className="contact-socials">
                <span className="section-kicker">Social Connection</span>
                <div className="contact-social-grid">
                  {socialLinks.map((item) => (
                    <ScrollReveal
                      as="a"
                      key={item.label}
                      href={item.href}
                      target="_blank"
                      rel="noreferrer"
                      className="contact-social-card"
                      delay={120 + socialLinks.indexOf(item) * 60}
                      distance={14}
                    >
                      <span>{item.icon}</span>
                      <strong>{item.label}</strong>
                    </ScrollReveal>
                  ))}
                </div>
              </div>
            </ScrollReveal>
          </Col>

          <Col lg={7}>
            <ScrollReveal
              as="form"
              className="contact-form-card"
              onSubmit={handleSubmit}
              variant="left"
              delay={80}
              distance={28}
            >
              <div className="contact-form-head">
                <span className="section-kicker">Send Mail</span>
                <h2>Compose your message.</h2>
                <p>
                  This generates a mail draft to
                  {" "}
                  <strong>itsshankar35@gmail.com</strong>
                  {" "}
                  using Gmail compose, with `mailto:` available as fallback.
                </p>
              </div>

              <div className="contact-topic-row">
                {topics.map((item) => (
                  <button
                    key={item}
                    type="button"
                    className={subject === item ? "topic-chip active" : "topic-chip"}
                    onClick={() => setSubject(item)}
                  >
                    {item}
                  </button>
                ))}
              </div>

              <Row className="g-3">
                <Col md={6}>
                  <label className="contact-label" htmlFor="contact-name">
                    Name
                  </label>
                  <input
                    id="contact-name"
                    className="contact-input"
                    type="text"
                    placeholder="Your name"
                    value={name}
                    onChange={(event) => setName(event.target.value)}
                  />
                </Col>
                <Col md={6}>
                  <label className="contact-label" htmlFor="contact-subject">
                    Subject
                  </label>
                  <input
                    id="contact-subject"
                    className="contact-input"
                    type="text"
                    placeholder="What is this about?"
                    value={subject}
                    onChange={(event) => setSubject(event.target.value)}
                  />
                </Col>
                <Col xs={12}>
                  <label className="contact-label" htmlFor="contact-message">
                    Message
                  </label>
                  <textarea
                    id="contact-message"
                    className="contact-input contact-textarea"
                    placeholder="Write your message here"
                    value={message}
                    onChange={(event) => setMessage(event.target.value)}
                  />
                </Col>
              </Row>

              <div className="contact-mail-preview">
                <span className="section-kicker">Preview</span>
                <p>{finalSubject}</p>
                <small>{finalBody}</small>
              </div>

              <div className="contact-actions">
                <button type="submit" className="button-primary">
                  <FiSend /> Open in Gmail
                </button>
                <a className="button-secondary" href={mailtoHref}>
                  Use Mail App
                </a>
              </div>
            </ScrollReveal>
          </Col>
        </Row>
      </Container>
      <ScrollToTop />
    </Container>
  );
}

export default Contact;
